// The voice screen is read by the rep and by the manager coaching them. Words
// about "your voice" are only true for the rep; anyone else is told about
// "their" voice.
export function voiceWords(isSelf) {
  return isSelf
    ? { Your: "Your", your: "your", You: "You" }
    : { Your: "Their", your: "their", You: "They" };
}
